import { render } from "./Progression.vue?vue&type=template&id=b89d88d2&scoped=true"
import script from "./Progression.vue?vue&type=script&lang=js"
export * from "./Progression.vue?vue&type=script&lang=js"

import "./Progression.vue?vue&type=style&index=0&id=b89d88d2&lang=scss&scoped=true"

import exportComponent from "C:\\wamp2022\\www\\emotivapp\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b89d88d2"]])

export default __exports__